import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/useAuth';
import { useOnboarding } from '@/hooks/useOnboarding';
import { useMinShow } from '@/hooks/useMinShow';
import FullScreenLoader from '@/components/ui/FullScreenLoader';
import LandingPage from './LandingPage';

export default function IndexPage() {
  const { session, isAuthLoading, isProfileLoading } = useAuth();
  const { hasCompletedOnboarding } = useOnboarding();

  const showLoader = useMinShow(isAuthLoading || isProfileLoading, 1400);

  if (isAuthLoading) return <FullScreenLoader />;
  if (!session) return <LandingPage />;
  if (showLoader) return <FullScreenLoader />;

  return (
    <Navigate
      to={hasCompletedOnboarding ? '/home' : '/onboarding/name'}
      replace
    />
  );
}
